import { COMMON_TEXT } from '@/helpers/common-text';
import {
  COMPONENT_ID_GROUP,
  SIDEBAR_CATEGORY
} from '@/helpers/constants';

export const router = [
  {
    icon: 'employee-locations',
    url: '/employee-locations',
    text: COMMON_TEXT.EMPLOYEE_LOCATIONS,
    title: COMMON_TEXT.EMPLOYEE_LOCATIONS,
    category: SIDEBAR_CATEGORY.COMMUNICATION,
    componentIdGroup: COMPONENT_ID_GROUP.EMPLOYEE_LOCATIONS,
  },
  {
    icon: 'meeting-room-usage',
    url: '/meeting-room-usage',
    text: COMMON_TEXT.MEETING_ROOM_USAGE,
    title: COMMON_TEXT.MEETING_ROOM_USAGE,
    category: SIDEBAR_CATEGORY.COMMUNICATION,
    componentIdGroup: COMPONENT_ID_GROUP.ROOM_AVAILABILITIES,
  },
  {
    icon: 'people-counts',
    url: '/people-counts',
    text: COMMON_TEXT.PEOPLE_COUNTS,
    title: COMMON_TEXT.PEOPLE_COUNTS,
    category: SIDEBAR_CATEGORY.COMMUNICATION,
    componentIdGroup: COMPONENT_ID_GROUP.PEOPLE_COUNTS,
  },
  {
    icon: 'employee-attendance',
    url: '/employee-attendance',
    text: COMMON_TEXT.EMPLOYEE_ATTENDANCE_RATE,
    title: COMMON_TEXT.EMPLOYEE_ATTENDANCE_RATE,
    category: SIDEBAR_CATEGORY.COMMUNICATION,
    componentIdGroup: COMPONENT_ID_GROUP.EMPLOYEE_ATTENDANCE,
  },
  {
    icon: 'wireless',
    url: '/performances',
    text: COMMON_TEXT.NETWORK,
    title: COMMON_TEXT.NETWORK,
    category: SIDEBAR_CATEGORY.FACILITY,
    componentIdGroup: COMPONENT_ID_GROUP.PERFORMANCES,
  },
  {
    icon: 'air-quality',
    url: '/air-quality',
    text: COMMON_TEXT.AIR_QUALITY,
    title: COMMON_TEXT.AIR_QUALITY,
    category: SIDEBAR_CATEGORY.FACILITY,
    componentIdGroup: COMPONENT_ID_GROUP.ENVIRONMENTS,
  },
  {
    icon: 'meeting-room-outlook-usage',
    url: '/meeting-room-outlook-usage',
    text: COMMON_TEXT.MEETING_ROOM_OUTLOOK_USAGE,
    title: COMMON_TEXT.MEETING_ROOM_OUTLOOK_USAGE,
    category: SIDEBAR_CATEGORY.FACILITY,
    componentIdGroup: COMPONENT_ID_GROUP.MEETING_ROOMS,
  },
  {
    icon: 'analytics',
    url: '/people-counts-analysis',
    text: COMMON_TEXT.PEOPLE_COUNTS_ANALYSIS,
    title: COMMON_TEXT.PEOPLE_COUNTS_ANALYSIS,
    category: SIDEBAR_CATEGORY.FACILITY,
    componentIdGroup: COMPONENT_ID_GROUP.PEOPLE_COUNTS_ANALYSIS,
  },
  {
    icon: 'device-status',
    url: '/device-status-overview',
    text: COMMON_TEXT.DEVICE_STATUS_OVERVIEW,
    title: COMMON_TEXT.DEVICE_STATUS_OVERVIEW,
    category: SIDEBAR_CATEGORY.FACILITY,
    componentIdGroup: COMPONENT_ID_GROUP.DEVICE_STATUS,
  },
  {
    icon: 'bcp-overview',
    url: '/bcp-overview',
    text: COMMON_TEXT.BCP,
    title: COMMON_TEXT.DEVICE_STATUS_OVERVIEW,
    category: SIDEBAR_CATEGORY.FACILITY,
    componentIdGroup: COMPONENT_ID_GROUP.BCP_OVERVIEW,
  },
  {
    icon: 'access-log',
    url: '/employee-access-log',
    text: COMMON_TEXT.EMPLOYEE_ACCESS_LOG,
    title: COMMON_TEXT.EMPLOYEE_ACCESS_LOG,
    category: SIDEBAR_CATEGORY.LABOR,
    componentIdGroup: COMPONENT_ID_GROUP.EMPLOYEE_MANAGEMENTS,
  },
  {
    icon: 'data-config',
    url: '/configuration',
    text: COMMON_TEXT.DATA_CONFIGURATION,
    title: COMMON_TEXT.DATA_CONFIGURATION,
    category: SIDEBAR_CATEGORY.ORGANIZATION,
    componentIdGroup: COMPONENT_ID_GROUP.CONFIGURATION,
  },
  {
    icon: 'signage',
    url: '/signage-components',
    text: COMMON_TEXT.SIGNAGE_MODE,
    title: COMMON_TEXT.SIGNAGE_MODE,
    category: SIDEBAR_CATEGORY.ORGANIZATION,
    componentIdGroup: COMPONENT_ID_GROUP.SIGNAGE_COMPONENTS,
  },
];
